import { render, staticRenderFns } from "./dashboard-content.vue?vue&type=template&id=51ee176d&"
import script from "./dashboard-content.vue?vue&type=script&lang=js&"
export * from "./dashboard-content.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-content.vue?vue&type=style&index=0&id=51ee176d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports